import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

/*
 * Third party
 */

import { i18nTranslate } from './utils/i18n-translate'
import VModal from 'vue-js-modal'
import BootstrapVue from 'bootstrap-vue'
import Vuetify from 'vuetify'
import PrettyCheckbox from 'pretty-checkbox-vue'
import Toasted from 'vue-toasted'
import VueClipboard from 'vue-clipboard2'
import VueAB from 'vue-a2b'
import VueScrollTo from 'vue-scrollto'
import VueNoty from 'vuejs-noty'
import checkbox from 'vue-material-checkbox'
import VueCookies from 'vue-cookies'
import VueAnalytics from 'vue-analytics'
import VueGtm from '@gtm-support/vue2-gtm'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import vSelect from 'vue-select'
import { rtdbPlugin } from 'vuefire'

/*
 * CSS
 */
import 'vuetify/dist/vuetify.min.css'
import 'vuejs-noty/dist/vuejs-noty.css'
import 'vue-select/dist/vue-select.css'

/*
 * LOGS
 */

// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'

const isProd = process.env.NODE_ENV === 'production'
const gAnalyticsProd = 'UA-126634379-1'
// const gAnalyticsDev = 'UA-126622059-1'

const version = 'v1.6.15'
console.log('V', version)

/*
 * Client LOGS
 */

Sentry.init({
  dsn:
    'https://4558a8b9ded74895909518b9e18690a2@o132587.ingest.sentry.io/1421241',
  integrations: [new VueIntegration({ Vue, attachProps: true })],
})

Vue.use(VueCookies)

Vue.use(rtdbPlugin)

Vue.use(Vuetify, {
  theme: {
    primary: '#24c48b',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c',
  },
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueAB)
Vue.use(VueScrollTo)
Vue.use(VueNoty)
Vue.use(BootstrapVue)
Vue.use(VueAnalytics, {
  id: gAnalyticsProd,
  router,
  debug: {
    eneable: !isProd,
    sendHitask: isProd,
  },
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href,
      }
    },
  },
})
Vue.use(VueGtm, {
  id: 'GTM-MQGXHH5',
  enabled: true,
  debug: !isProd,
  vueRouter: router,
  ignoredViews: ['home'],
})
Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
  dialog: true,
})
Vue.use(PrettyCheckbox)
Vue.use(checkbox)
Vue.use(Toasted, {
  position: 'top-center',
  duration: 2000,
  singleton: true,
})
Vue.component('v-select', vSelect)

/*
 * APP
 */ Vue.config.productionTip = process.env.NODE_ENV === 'production'

const i18n = i18nTranslate(Vue)

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app
}
